import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { BILL_DETAILS, COMPANY_DETAILS } from '../../../data/url';
import InvoiceAddress from '../layout/invoice/InvoiceAddress';
import InvoiceTable from '../layout/invoice/InvoiceTable';
import InvoiceHeader from '../layout/invoice/InvoiceHeader';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import { useParams, Link } from 'react-router-dom';
import httpClient from '../../../http/HttpRequest';
import { generatePDF } from '../../pdf/GeneratePDF';

export default function ViewBill() {

     const [bill, setBill] = useState({});
     const [details, setBillDetails] = useState([]);
     const [company, setCompanyDetails] = useState({});
     const [vendor, setVendor] = useState({});

     const { t } = useTranslation();
     const { id } = useParams();

     const componentRef = React.useRef();

     const handlePrint = useReactToPrint({
          content: () => componentRef.current,
     });

     useEffect(() => {
          getOrderDetails();
          getCompanyDetails();
     }, []);


     const getOrderDetails = async (e) => {
          const res = await httpClient.post(BILL_DETAILS, { bill_id: id });
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    let b = result.data.bill;
                    b['po_date'] = b['bill_date'];
                    b['valid_until'] = b['due_date'];
                    setBill(b);
                    setBillDetails(result.data.details);
                    setVendor(result.data.vendor);
               }
          }
     }

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setCompanyDetails(result.data);

               }
          };
     }

     const makePdf = () => {
          let filename = `${bill.bill_number}-BILL`;
          generatePDF(filename);       
          
     };
     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="view_bill" subTitle="bills" subTitleLink="root/bill" />
                    <div className="card col-md-11 m-auto" id="invoice">
                         <div className="card-body" id="print_section" ref={componentRef}>
                              <InvoiceHeader title="bill" number={`${bill.prefix}-${bill.bill_number}`} />
                              <InvoiceAddress title="vendor" customer={vendor} company={company} order={bill} />
                              <InvoiceTable title="bill" products={details} order={bill} company={company} customer={vendor} />
                         </div>
                         <div className='text-center'>
                              <Link to={`/root/bill/edit/${id}`} type="button" className="btn btn-sm btn-primary btn-icon-text m-1">
                                   {t('edit')}
                              </Link>
                              <button className="btn btn-sm btn-danger btn-icon-text m-1" onClick={makePdf}>{t('pdf')}</button>
                              <button className="btn btn-sm btn-info btn-icon-text m-1" onClick={handlePrint}>{t('print')}</button>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
